import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { maintenanceSelector } from 'store/entities/config/selectors';
import { getMaintenance } from 'store/entities/config/thunks';

export const useMaintenance = () => {
  const dispatch = useDispatch();
  const { maintenanceMode, maintenanceMessage } = useSelector(maintenanceSelector);

  useEffect(() => {
    dispatch(getMaintenance());
  }, []);

  return {
    isMaintenance: maintenanceMode,
    maintenanceMessage: maintenanceMessage,
  };
};
